// extracted by mini-css-extract-plugin
export default {"imgContainer":"imgContainer___ytEP3","clickable":"clickable___pntHD"};